export default "__VITE_ASSET__211e20d7__"